<template>
  <div class="summary">
    <div class="summary__container">
      <div class="summary__card">
        <PageHeader
          class="summary__header-mobile"
          :product="product"
          :is-primary-headline="false"
        />
        <SummarySwiper
          :product="product"
          :navigation-height="navigationHeight"
        />
        <div class="summary__right-side">
          <PageHeader class="summary__header" :product="product" />
          <Configuration
            v-if="configurations?.length > 0"
            :product="product"
            :configurations="configurations"
          />
          <SummaryPromotion
            v-if="null !== getActivePromotion(product) && product.isOrderable"
            :category="getActivePromotion(product)"
          />
          <div v-if="0 !== product.gifts.length" class="summary__gifts">
            <ProductGift
              v-for="giftProduct in product.gifts"
              :key="giftProduct.id"
              :product="giftProduct"
              width="100%"
            />
          </div>
          <ProductCarousel
            :products="alternativeProducts"
            :without-navigation="true"
            :card-width="680 <= width ? 190 : 270"
            background-color="var(--color-sky-lightest)"
          >
            <template #title>
              <p class="summary__alternative-title">
                {{ _T("@Alternative products title") }}
              </p>
            </template>
            <template #productCard="productCardProps">
              <AlternativeProductCard :product="productCardProps.product" />
            </template>
          </ProductCarousel>
          <Purchase :product="product" />
          <template v-if="'outOfProduction' !== product.status">
            <CreditPayment v-if="product.isOrderable" :product="product" />
            <DeliveryBlock :product="product" />
            <PaymentMethods />
          </template>
        </div>
      </div>
      <SimilarProductCarousel :product="product" :limit="12" />
    </div>
    <Description :product="product" />
    <SummaryReviews :product="product" :reviews="reviews" />
  </div>
</template>

<script setup>
import { Product } from "~/models/product.model";
import Purchase from "~/modules/product/ui/components/Purchase.vue";
import DeliveryBlock from "~/modules/product/ui/pages/Summary/DeliveryBlock.vue";
import PaymentMethods from "~/modules/product/ui/pages/Summary/PaymentMethods.vue";
import Description from "~/modules/product/ui/pages/Summary/Description.vue";
import SummaryReviews from "~/modules/product/ui/pages/Summary/SummaryReviews.vue";
import SummarySwiper from "~/modules/product/ui/pages/Summary/SummarySwiper.vue";
import CreditPayment from "~/modules/product/ui/pages/Summary/CreditPayment.vue";
import Configuration from "~/modules/product/ui/pages/Summary/Configuration.vue";
import SimilarProductCarousel from "~/modules/shared/sliders/productCarousels/SimilarProductCarousel.vue";
import { useCategoriesStore } from "~/store/categoriesStore";
import { promotionCategoryCode } from "~/config/category.config";
import SummaryPromotion from "~/modules/product/ui/pages/Summary/SummaryPromotion.vue";
import PageHeader from "~/modules/product/ui/components/PageHeader.vue";
import ProductGift from "~/modules/shared/productGift/ProductGift.vue";
import ProductCarousel from "~/modules/shared/sliders/ProductCarousel.vue";
import AlternativeProductCard from "~/modules/shared/productCard/AlternativeProductCard.vue";

const props = defineProps({
  product: { type: Product, required: true },
  configurations: { type: [Array, null], required: false },
  navigationHeight: { type: Number, required: false },
  reviews: { type: Object, required: true },
  alternativeProducts: { type: Array, required: false },
});

const categoriesStore = useCategoriesStore();
const { getCategoryById } = storeToRefs(categoriesStore);

const { width } = useWindowSize();

const getActivePromotion = (product) => {
  let promotion = null;

  product.categories.forEach(({ id }) => {
    const currentCategory = getCategoryById.value(id);

    if (
      promotionCategoryCode === currentCategory.parent?.code &&
      !isPromotionEnded(currentCategory)
    ) {
      promotion = currentCategory;
    }
  });

  return promotion;
};
</script>
